import { useLocation } from "react-router";

function useShowToolbar() {
  const location = useLocation();

  //Todo: Check if we could just enable the toolbar for the timetable
  const isTeamDiary = location.pathname.includes("/team-diary/");
  const isStep = location.pathname.includes("/step/");
  const isLibrary = location.pathname.includes("/library");
  const isShowroom = location.pathname.includes("/showroom");
  const isInvite = location.pathname.includes("/invite");
  const isGlossary = location.pathname.includes("/glossary");

  const showToolbar =
    !isTeamDiary &&
    !isStep &&
    !isLibrary &&
    !isShowroom &&
    !isInvite &&
    !isGlossary;

  return showToolbar;
}

export default useShowToolbar;
